import { render, staticRenderFns } from "./FoyerCategory.vue?vue&type=template&id=d5495170"
import script from "./FoyerCategory.vue?vue&type=script&lang=js"
export * from "./FoyerCategory.vue?vue&type=script&lang=js"
import style0 from "./FoyerCategory.vue?vue&type=style&index=0&id=d5495170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports